var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticClass:"flex w-full justify-center items-center",staticStyle:{"min-height":"250px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }